<template>
  <b-modal
    v-model="showModal"
    size="lg"
    id="crtcreator-channel-modal"
    :title="edited.id ? 'Edit channel' : 'Add channel'"
    :ok-title="isFormLoading ? 'Saving...' : 'Save'"
    :ok-disabled="isFormLoading"
    cancel-variant="outline-secondary"
    @ok="onSubmit($event)"
  >
    <b-form>
      <b-form-group label="Name" label-for="channel-name">
        <b-form-input id="channel-name" v-model="edited.name" placeholder="Name" />
        <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
      </b-form-group>
      <b-form-group label="URL" label-for="channel-url">
        <b-form-input id="channel-url" v-model="edited.url" placeholder="https://..." />
        <small v-if="errors.url" class="text-danger">{{ errors.url }}</small>
      </b-form-group>
      <b-form-group label="Notes" label-for="channel-notes">
        <b-form-textarea id="channel-notes" v-model="edited.notes" rows="3" />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BFormTextarea, BModal,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { toastFailure, toastSuccess } from '@/libs/toastification'

const defaults = () => ({
  id: null,
  name: '',
  url: '',
  notes: '',
})

function firstError(value) {
  if (Array.isArray(value)) {
    return value[0] || ''
  }
  return value || ''
}

export default {
  components: {
    BForm, BFormGroup, BFormInput, BFormTextarea, BModal,
  },
  props: {
    record: { type: Object, default: null },
    clickDate: { type: Date, default: null },
  },
  emits: ['saved'],
  data() {
    return {
      showModal: false,
      isFormLoading: false,
      edited: defaults(),
      errors: {},
    }
  },
  watch: {
    clickDate() {
      this.errors = {}
      if (this.record && this.record.id) {
        this.edited = {
          id: this.record.id,
          name: this.record.name || '',
          url: this.record.url || '',
          notes: this.record.notes || '',
        }
      } else {
        this.edited = defaults()
      }
      this.showModal = true
    },
  },
  methods: {
    ...mapActions({
      addItem: 'crtcreator/channels/addItem',
      updateItem: 'crtcreator/channels/updateItem',
    }),
    applyServerErrors(error) {
      const payload = error?.response?.data
      if (!payload || typeof payload !== 'object') {
        return false
      }
      const next = {}
      if (payload.name) next.name = firstError(payload.name)
      if (payload.url) next.url = firstError(payload.url)
      if (Object.keys(next).length) {
        this.errors = next
        return true
      }
      return false
    },
    async onSubmit(event) {
      event.preventDefault()
      this.errors = {}
      if (!String(this.edited.name || '').trim()) {
        this.errors.name = 'Name is required'
      }
      if (!String(this.edited.url || '').trim()) {
        this.errors.url = 'URL is required'
      }
      if (Object.keys(this.errors).length) return

      this.isFormLoading = true
      const payload = {
        name: this.edited.name,
        url: this.edited.url,
        notes: this.edited.notes || null,
      }
      try {
        let saved
        if (this.edited.id) {
          saved = await this.updateItem({ id: this.edited.id, payload })
          toastSuccess('Successfully updated')
        } else {
          saved = await this.addItem(payload)
          toastSuccess('Successfully added')
        }
        this.showModal = false
        this.$emit('saved', saved)
      } catch (e) {
        if (!this.applyServerErrors(e)) {
          toastFailure('Failed to save')
        }
      } finally {
        this.isFormLoading = false
      }
    },
  },
}
</script>
